import * as React from "react";
import type { SVGProps } from "react";
const ArrowDownSmallPlusIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M17.207 8.793a1 1 0 0 0-1.414 0L11.5 13.086 7.207 8.793a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0 0-1.414" clipRule="evenodd" /></svg>;
export default ArrowDownSmallPlusIcon;